var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg020IconConfirmCancelInprogress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thilina",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ewallet-copy-8",
    transform: "translate(-919.000000, -446.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31-Copy-3",
    transform: "translate(741.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(178.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5AAAD0",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(21.718782, 21.756454) rotate(20.000000) translate(-21.718782, -21.756454) ",
    cx: 21.7187824,
    cy: 21.7564541,
    r: 15.4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    fill: "#FFFFFF",
    transform: "translate(10.450000, 35.750000) rotate(-319.000000) translate(-10.450000, -35.750000) ",
    points: "5.5 31.9 10.45 39.6 15.4 31.9"
  }), /*#__PURE__*/React.createElement("text", {
    id: "?",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 27,
    fontWeight: 400,
    fill: "#EE3F2D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.4345703,
    y: 31
  }, "?")))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg020IconConfirmCancelInprogress);
export default __webpack_public_path__ + "static/media/020-icon-confirm-cancel-inprogress.0775c27b4398b8fa3152a1eb749722e8.svg";
export { ForwardRef as ReactComponent };